import { useOutletContext } from 'react-router-dom'

import { type PlanningPeriodDetailQuery } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import useSearchParams from 'modules/core/hooks/useSearchParams'
import { HeadcountEmployeeSheet } from 'modules/planning/components/Headcount/EmployeeSheet'
import type { PeriodRoleContext } from 'modules/planning/roles'

type PeriodDetailContext = {
  period: PlanningPeriodDetailQuery['planning']['period']
  periodId: string
  roleContext: PeriodRoleContext | undefined
  canCreateRequest: boolean
}

const PeriodEmployeeSheetTab = () => {
  const { period, periodId, roleContext, canCreateRequest } =
    useOutletContext<PeriodDetailContext>()
  const { managerId } = useSearchParams<{ managerId?: string }>()
  const { company } = useCurrentSession()

  const submissionPeriodId = period?.submissionPeriods?.[0]?.id
  const planningId = roleContext?.roles?.[0]?.planningIds?.[0] ?? undefined

  return (
    <HeadcountEmployeeSheet
      periodId={periodId}
      planningId={planningId}
      submissionPeriodId={submissionPeriodId}
      companyId={company.id}
      roleContext={roleContext}
      canCreateRequest={canCreateRequest}
      periodStatus={period?.status}
      initialManagerId={managerId}
    />
  )
}

export default PeriodEmployeeSheetTab
